import type { QueryBuilder } from "@cgarciagarcia/react-query-builder";

import { api } from "~/api";
import {
  activitiesResponseSchema,
  activityDetailResponseSchema,
} from "./schemas";

export const getActivities = async ({
  queryBuilder,
}: {
  queryBuilder?: QueryBuilder<Record<string, string> | undefined>;
}) => {
  const response = await api.get(
    `/admin/activities${queryBuilder?.build() ?? ""}`,
  );

  return activitiesResponseSchema.parse(response.data);
};

export const getActivity = async (id: number | string) => {
  const response = await api.get(`/admin/activities/${id}`);

  return activityDetailResponseSchema.parse(response.data).data;
};
